import { render, staticRenderFns } from "./Mir.vue?vue&type=template&id=a6f22990&"
import script from "./Mir.vue?vue&type=script&lang=ts&"
export * from "./Mir.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports